// The follwoing order allows to use indexOf and compare the indexes to select the highest priority:
//   - begin of the array - lowest priority;
//   - end of the array - highest priority;
// This also works when some taxonomy is not in this array (i.e. index is -1).
export default [
  'Volleyball',
  'Basketball',
  'Running',
];
